module.exports = __webpack_public_path__ + "img/export_office2.53d1fcb1.png";